export { PaperPlaneVector } from "./paper-plane-vector";
